import { useState } from "react";
import { Loader2, Unlink } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const DisconnectBank = ({ onDone }) => {
  const [busy, setBusy] = useState(false);
  const disconnect = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/wallet/connect/disconnect");
      toast.success("Bank disconnected. You can connect a new one anytime.");
      onDone();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't disconnect your bank");
    } finally { setBusy(false); }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button type="button" data-testid="disconnect-bank-btn"
          className="mt-2 w-full h-9 rounded-xl text-xs text-[#F87171] hover:bg-[#EF4444]/10 flex items-center justify-center gap-1.5 transition-colors">
          <Unlink className="h-3.5 w-3.5" /> Disconnect bank
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="disconnect-bank-dialog" className="bg-[#121212] border-[#27272A] text-[#F3F4F6]">
        <AlertDialogHeader>
          <AlertDialogTitle>Disconnect your bank?</AlertDialogTitle>
          <AlertDialogDescription className="text-[#9CA3AF]">
            This closes your Stripe payout account and removes your bank from NoteLosh. Your NoteLosh wallet balance stays safe, and you can connect a bank again anytime to cash out.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="disconnect-bank-cancel" className="bg-transparent border-[#27272A] text-[#F3F4F6] hover:bg-[#1E1E1E] hover:text-white">Keep it</AlertDialogCancel>
          <AlertDialogAction data-testid="disconnect-bank-confirm" onClick={disconnect} disabled={busy} className="bg-[#EF4444] hover:bg-[#DC2626] text-white">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Disconnect"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
